export default __webpack_public_path__ + "static/O0315-db52d84e6c5908df0e01e31ddde452ea.png";